import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { OtpAttempts } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/otp-attempts")({
  head: () => ({ meta: [{ title: "OTP Attempts | LeadXkids Admin" }, { name: "robots", content: "noindex" }] }),
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <OtpAttempts />
    </RouteGuard>
  ),
});
